import { QUERY_KEY } from 'constants/globalConstants'
import ApiService from 'apiService'
import { useQuery } from 'react-query'

const useNodeFilter = (id) => {
    return useQuery(QUERY_KEY.GET_NODE_FILTER, ()=>ApiService.nodeFilter(id), {retry: false})
}

export default useNodeFilter